export default __webpack_public_path__ + "static/media/bellIconBlue.d2141295.svg";